import { useNavigation } from "../../../contexts/NavigationContext";

/**
 * Derives sysconfig parameters from NavigationContext.
 * Sysconfig is always derived from the selected microgrid name,
 * NOT from timeSeriesFileName (which is for simulation results only).
 *
 * @returns {{ storageAccount: string, microgridName: string, datasetName: string|null, loading: boolean, error: Error|null }}
 */
export function useTimeseriesSysconfig() {
  const {
    storageAccountName: storageAccount,
    selectedMicrogrid: microgridName,
  } = useNavigation();

  const datasetName = microgridName ? `${microgridName}-sysconfig.json` : null;

  return {
    storageAccount: storageAccount || "",
    microgridName: microgridName || "",
    datasetName,
    loading: false,
    error: null,
  };
}
